import { procurementAPI } from "../../axios";

export const actions = {

    // ApiResourceDetail
    GetApiResourceDetailByApiResource(context, data){
        return procurementAPI.get(`PrePlanningApiResourceDetail/PrePlanningApiResource/${data}`);
    },
    GetSingleApiResourceDetail(context, data){
        return procurementAPI.get(`PrePlanningApiResourceDetail/${data}`);
    },
    UpdateApiResourceDetail(context, data){
        return procurementAPI.put(`PrePlanningApiResourceDetail/${data.id}`, data);
    },
    DeleteApiResourceDetail(context, data){
        return procurementAPI.delete(`PrePlanningApiResourceDetail/${data}`);
    },
    CreateApiResourceDetail(context, data){
        return procurementAPI.post(`PrePlanningApiResourceDetail/CreatePrePlanningApiResourceDetail`, data);
    }

}